import React from 'react';

import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { ButtonType } from '@nhl/nhl-breakaway-ui';

import { playersAndTeamsActionCreators } from '~/redux/ducks/playersAndTeams';
import { commonMessages } from '~/utility/commonMessages';

import { IconButton } from '../advancedButton/styles';

const LegendButton = () => {
    const dispatch = useDispatch();
    const intl = useIntl();
    const isLegendVisible = useSelector((state) => state.playersAndTeams.isLegendActive);

    const clickHandler = () => {
        dispatch(playersAndTeamsActionCreators.showLegend(!isLegendVisible));
    };

    return (
        <IconButton
            variant={ButtonType.Secondary}
            onClick={clickHandler}
            title={intl.formatMessage(commonMessages.labels.legend)}
        >
            <InfoOutlinedIcon />
        </IconButton>
    );
};

export default LegendButton;
